import { CatListItem } from '@blocks-react/components/ListItem';
import { ReactElement } from 'react';

export type EquipmentMoreActionListItemProps = {
  children?: ReactElement;
  onSelect: () => void;
  classNames?: string;
};

export const EquipmentMoreActionListItem = ({
  children,
  onSelect,
  classNames
}: EquipmentMoreActionListItemProps) => {
  return <CatListItem onBlSelect={onSelect} className={classNames}>{children}</CatListItem>;
};
